import { Component } from "react";
import Layout from "../../component/layout";
import NextSeoModule from "../../component/next-seo";
 import Azuredeveloptemplate from "../../component/course/azure-developer";

export default class Azuredevelopinkolkata extends Component {
 
  render() {
   
    const title = "Azure Developer"   
    const url ="azure-developer"
     const url1 ="-training-in-kolkata"
    const location = "kolkata" 
    const location1="Training in Kolkata" 
    return(
      <>
          <NextSeoModule
            title={`${title} ${location1} - learnsoft.org`}
            description={`Enroll in Azure Developer Training in ${location} and Gain the Skills to Build, Test, and Deploy Applications on Microsoft Azure for Seamless Cloud Development.`}
            url={`${location}/${url}${url1}`}
           img={`course/${url}.webp`}
                      keyword={`${title} training in ${location}, ${title} certification in ${location}, Online ${title}  Training in ${location}, ${title} Online Training in ${location}, ${title} Syllabus, ${title} course in ${location}, ${title} classes in ${location}, ${title} institute in ${location}, Best ${title} training institute in ${location}, ${title} training and certification in ${location}, Best ${title} training in ${location}, ${title} coaching in ${location}, ${title} training center in ${location}, ${title} training provider in ${location}`}
          />
        <Layout navbarBackgroundColor="#281E1E">
         <Azuredeveloptemplate url1={url1} title={title} url={url} relatedlocation={location} location={location} location1={location1} />
        </Layout>
      </>
    );
  }
}
